import React, { useEffect, useState } from 'react'
import protectionsApi from 'screens/Protection/protection.api'
import eventBus from 'services/eventBus'
import Button from 'shared/Buttons/Button/Button'
import TrashButton from 'shared/Buttons/TrashButton'
import Card from 'shared/Cards/Card'
import TextField from 'shared/Forms/TextField'
import { IArtefact, ITeamArtefactsDto, ITeamResult } from 'screens/Protection/protection.types'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import { useParams } from 'react-router-dom'
import TextInput from 'shared/Inputs/TextInput'

type Props = {
  teamResult: ITeamResult | null
}

type ProtectionItem = {
  id: number
  title: string
  link: string
}

export default function ProtectionsInfoOptional({ teamResult }: Props) {
  const [items, setItems] = useState<ProtectionItem[]>([])
  const { wait } = useHttpLoader()
  const params = useParams()

  useEffect(() => {
    const artefactRecord = teamResult?.team?.artefacts?.[0]

    if (!artefactRecord?.artefacts) {
      setItems([])
      return
    }

    try {
      const parsed = JSON.parse(artefactRecord.artefacts)

      setItems(
        parsed.map((item: any, index: number) => ({
          id: Date.now() + index,
          title: item.key ?? '',
          link: item.value ?? '',
        }))
      )
    } catch (error) {
      console.error('Ошибка парсинга артефактов', error)
      setItems([])
    }
  }, [teamResult])

  const addRow = () => {
    setItems((prev) => [
      ...prev,
      {
        id: Date.now(),
        title: '',
        link: '',
      },
    ])
  }

  const removeRow = (id: number) => {
    setItems((prev) => prev.filter((item) => item.id !== id))
  }

  const changeField = (id: number, field: 'title' | 'link', value: string) => {
    setItems((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              [field]: value,
            }
          : item
      )
    )
  }

  const handleSave = () => {
    if (!params?.teamId || !params?.id) return

    const filteredItems = items.filter((item) => item.title.trim() || item.link.trim())

    const artefactsPayload: IArtefact[] = filteredItems.map((item) => ({
      key: item.title,
      value: item.link,
    }))

    const payload: ITeamArtefactsDto = {
      teamId: Number(params.teamId),
      defenceId: params.id,
      artefacts: artefactsPayload,
    }

    wait(protectionsApi.addArtefacts(payload), (resp) => {
      if (resp.status !== 'success') return

      eventBus.pub('ntf.message', {
        message: 'Артефакты сохранены',
        type: 'info',
      })
    })
  }

  return (
    <Card type='normal' style={{ marginTop: '12px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {items.map((item) => (
          <div
            key={item.id}
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              gap: 16,
            }}
          >
            <div style={{ flex: 1 }}>
              <TextField header='Название'>
                <TextInput
                  name={`title-${item.id}`}
                  value={item.title}
                  onChange={(value) => changeField(item.id, 'title', value)}
                  required={false}
                />
              </TextField>
            </div>

            <div style={{ flex: 1 }}>
              <TextField header='Ссылка'>
                <TextInput
                  name={`link-${item.id}`}
                  value={item.link}
                  onChange={(value) => changeField(item.id, 'link', value)}
                  required={false}
                />
              </TextField>
            </div>

            <TrashButton onClick={() => removeRow(item.id)} />
          </div>
        ))}

        <div style={{ display: 'flex', gap: 12 }}>
          <Button onClick={addRow} fullWidth={false} theme='grey-outline' disabled={items.length >= 4}>
            Добавить
          </Button>

          <Button onClick={handleSave} fullWidth={false}>
            Сохранить
          </Button>
        </div>
      </div>
    </Card>
  )
}
